export const OrgEntityType = [
  {
    name: 'Public',
    value: 'Public',
    key: 'Public',
    id: 'Public',
  },
  {
    name: 'Private',
    value: 'Private',
    key: 'Private',
    id: 'Private',
  },
  {
    name: 'Research Organisation',
    value: 'Research Organisation',
    key: 'Research Organisation',
    id: 'Research Organisation',
  },
  {
    name: 'University',
    value: 'University',
    key: 'University',
    id: 'University',
  },
  {
    name: 'Startup/MSME',
    value: 'Startup/MSME',
    key: 'Startup/MSME',
    id: 'Startup/MSME',
  },
  {
    name: 'NGO / Not for profit organization',
    value: 'NGO / Not for profit organization',
    key: 'NGO / Not for profit organization',
    id: 'NGO / Not for profit organization',
  },
];
